import React from 'react'

const GroupVolumetryHome: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_555_29622)" />
    <path
      d="M28.9443 49.5001C25.422 49.5001 21.9538 49.5001 18.4314 49.5001C16.7515 49.5001 16.1554 48.7414 16.4263 47.1699C17.456 41.3173 22.4957 36.9279 28.3482 36.7112C34.5259 36.4944 39.9992 40.5587 41.4081 46.357C42.0042 48.7414 41.4081 49.5001 38.9696 49.5001C35.6098 49.5001 32.3041 49.5001 28.9443 49.5001Z"
      fill="white"
    />
    <path
      d="M28.9985 20.5081C32.7919 20.5081 35.8265 23.4885 35.8265 27.2277C35.8265 30.8584 32.6293 34.0015 28.9443 34.0015C25.2594 34.0015 22.1705 30.8584 22.1705 27.1735C22.1705 23.4343 25.151 20.5081 28.9985 20.5081Z"
      fill="white"
    />
    <path
      d="M40.8662 20.5081C43.7925 20.5081 46.1768 22.188 47.2607 24.8434C48.3445 27.6071 47.64 30.5875 45.4724 32.4842C43.5215 34.2183 40.3785 34.6518 38.1025 33.5138C37.2896 33.0803 36.7477 32.8635 37.669 31.8339C39.9449 29.287 39.9449 25.7104 37.7231 23.1093C36.8019 22.0255 37.127 21.6461 38.1567 21.1584C39.0779 20.6707 40.0533 20.4539 40.8662 20.5081Z"
      fill="white"
    />
    <path
      d="M44.6053 49.2291C45.4723 48.0911 45.1472 47.0614 44.8762 45.9776C43.9008 42.5636 41.8416 39.9625 38.7527 38.1742C38.3192 37.9033 37.7231 37.8491 37.4521 37.3072C44.4427 34.9228 52.6255 40.0167 53.6009 47.224C53.7635 48.4162 53.3841 49.1749 52.0836 49.1749C49.5908 49.2291 47.2064 49.2291 44.6053 49.2291Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_555_29622"
        x1="34.5455"
        y1="0"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0062FF" />
        <stop offset="1" stopColor="#004BC2" />
      </linearGradient>
    </defs>
  </svg>
)

export default GroupVolumetryHome
